"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _crossMediumBlue = _interopRequireDefault(require("../../images/cross-medium-blue.svg"));
var _crossMediumWhite = _interopRequireDefault(require("../../images/cross-medium-white.svg"));
var _formatID = _interopRequireDefault(require("../../utils/formatID"));
var _lodash = require("lodash");
var _NavBar = require("./NavBar");
var _useIsChrome = _interopRequireDefault(require("../../utils/hooks/useIsChrome"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const NavMiniMenu = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    mouse,
    deployDropDown,
    openDropDown,
    closeDropDown,
    closeAllDropDowns,
    currentOpenMenu
  } = (0, _react.useContext)(_NavBar.NavBarContext);
  const {
    navText,
    links,
    Link,
    isOpen,
    displayIcons,
    theme,
    active,
    contentfulId,
    navBarWrapperRef,
    megaNavVariant
  } = props;
  const isCollapsed = links?.length > 4 ? true : false;
  const miniMenuTopValue = navBarWrapperRef?.current && megaNavVariant ? navBarWrapperRef?.current?.offsetTop + navBarWrapperRef?.current?.clientHeight : "100%";
  (0, _react.useImperativeHandle)(ref, e => {
    return {
      handleClick: () => {
        if (currentOpenMenu === contentfulId) {
          return closeDropDown(contentfulId);
        }
        return deployDropDown(e, contentfulId);
      }
    };
  });
  const {
    isChrome
  } = (0, _useIsChrome.default)();
  const [open, setOpen] = (0, _react.useState)(null);
  const mouseLeave = () => {
    setOpen(null);
  };
  const mouseOverFeature = feature => {
    setOpen(feature);
  };
  const mouseOverWithKeys = (event, contentfulId) => {
    if (!mouse) {
      // checks that a user hits the enter key to open the modal
      if (event.keyCode === 13) {
        openDropDown(contentfulId);
        //escape key closes the dropdown
      } else if (event.keyCode === 27) {
        closeDropDown();
      }
    }
  };
  const generateLinks = () => {
    return links?.filter(link => link?.url)?.map((link, index) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: link.text + " " + index,
        onMouseOver: () => mouseOverFeature(link.text),
        onMouseLeave: () => mouseLeave()
      }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
        className: `${mouse ? "ter-nav-mini-menu__drop-down__link" : "ter-nav-mini-menu__drop-down__link tabFocus"} ${link.text === open ? "ter-nav-mini-menu__drop-down__link--is-open" : ""} ${active ? `active` : ""}
            `,
        to: link.url,
        onClick: closeAllDropDowns,
        target: link.external ? "_blank" : "_self"
        // id={formatID(`${link.text}-navbar-group-link`)}
        ,
        Link: Link,
        depth: 2
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: `ter-nav-mini-menu__drop-down__link__text ${link.text === open ? "ter-nav-mini-menu__drop-down__link__text--is-open" : ""}`
      }, link.text)));
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    // id={uniqueId("mini-menu-")}
    className: `${mouse ? "ter-nav-mini-menu" : "ter-nav-mini-menu tabFocus"} ${isChrome ? "ter-nav-mini-menu--chrome-browser" : ""} ${displayIcons ? "ter-nav-mini-menu--with-icons" : ""}`,
    "aria-haspopup": "menu",
    "aria-expanded": isOpen,
    "aria-label": `${navText} menu`
  }, /*#__PURE__*/_react.default.createElement("p", {
    // id={formatID(`${navText}-ter-nav-mini-menu-text`)}
    tabIndex: mouse ? "" : "0",
    onClick: e => deployDropDown(e, contentfulId),
    onKeyDown: e => mouseOverWithKeys(e, contentfulId),
    className: `ter-nav-mini-menu__text ${isOpen && " ter-nav-mini-menu__text--is-open"}
        ${active ? `active` : ""}
        ${displayIcons ? "ter-nav-mini-menu__text--with-icons" : ""}
        ${theme ? `ter-nav-mini-menu__text--${theme}` : ""}
        `,
    "data-depth": 1
  }, navText, /*#__PURE__*/_react.default.createElement("img", {
    // id={uniqueId("cross-icon-")}
    src: theme === "blue" ? _crossMediumWhite.default : _crossMediumBlue.default,
    alt: "cross icon",
    "aria-label": isOpen ? "Opened" : "Closed",
    className: `ter-nav-icon-cross ${isOpen ? "ter-nav-icon-cross--is-open" : ""}`
  })), /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-nav-mini-menu__drop-down ${isOpen ? " ter-nav-mini-menu__drop-down--is-open" : ""} ${displayIcons ? "ter-nav-mini-menu__drop-down--with-icons" : ""}`,
    style: {
      top: miniMenuTopValue
    }
  }, generateLinks()));
});
var _default = NavMiniMenu;
exports.default = _default;